import React from 'react'
import { BsPhoneFill } from 'react-icons/bs'
import { FaLocationArrow } from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'
import Contact from './Contact'
import SocialMedia from './SocialMedia'

const ContactInfo = () => {
    return (
        <div className="flex flex-col space-y-3">

            <div>
                <h1 className="text-gray-700 font_poppins text-left pb-4 font-semibold text-lg">Before Contacting Us</h1>
                <p className="text-gray-500 text-sm">Lorem ipsum dolor sit amet, consectetur adipisici elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Non equidem invideo, miror magis posuere velit aliquet.</p>
            </div>

            {/* contact information   */}

            <div className="py-3">
                <h1 className="text-gray-700 font_poppins text-left pb-4 font-semibold text-lg">Contact Information</h1>

                {/* information  */}
                <div className="flex flex-col space-y-2">
                    {/* location  */}
                    <Contact text="Hollywood,NY-122,United Stated" icon={<FaLocationArrow className="text-indigo-700" />} />

                    {/* phone  */}
                    <Contact text="1-800-123-1234" icon={<BsPhoneFill className="text-indigo-700" />} />

                    {/* email  */}
                    <Contact text="languageschool@gmail.com" icon={<MdEmail className="text-indigo-700" />} />
                </div>

            </div>

            {/* Social Media Information   */}

            <div>
                <h1 className="text-gray-700 font_poppins text-left pb-4 font-semibold text-lg">Social Media</h1>
                <div className="flex items-center space-x-3">
                    {/* icons  */}
                    <SocialMedia />
                </div>
            </div>
        </div>
    )
}

export default ContactInfo
